<template>
<v-app>

    <Drawer current_item="menu_special_market_setting"></Drawer>


    <v-main class="ml-6 mr-6" v-if="permission.includes('VIEW_specialmarketorder')">

        <v-row align="end" justify="space-between">
        <v-col cols="12" class="text-md-h4 text-h5" align="left">
            Special Market Order
            </v-col>
        </v-row>

        <v-divider class="mb-6"></v-divider>

        <div align="right" class="ma-4">
            <v-btn  tile style="color:white" color="green" @click="csvExport()">
            <v-icon left>mdi-table-arrow-down</v-icon>Export CSV</v-btn>
        </div>

        <v-data-table
            :headers="headers"
            :items="rows"
            :items-per-page="10"
            class="elevation-1"
        >
        </v-data-table>

    
    </v-main>
</v-app>
</template>

<script>
import Drawer from '@/components/Drawer.vue'

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

export default {
    components: {
        Drawer
    },
    data () {
        return {
            permission : []
            ,headers : [
                {text: 'OrderID', value: 'order_id'}
                ,{text: 'LINE', value: 'line_name'}
                ,{text: 'สถานะ', value: 'status'}
                ,{text: 'สินค้าที่สั่ง', value: 'product_item_name'}
                ,{text: 'รวมที่ต้องจ่าย', value: 'total_bill_text'}
                ,{text: 'วันที่สั่ง', value: 'order_date'}
                ,{text: 'ชื่อผู้สั่ง', value: 'order_name'}
                //,{text: 'ชื่อผู้รับของ', value: 'reciver_name'}
                //,{text: 'เบอร์ผู้รับของ', value: 'reciver_tel'}
                //,{text: 'ที่อยู่จัดส่งชุด', value: 'reciver_address_1'}
                //,{text: '', value: 'reciver_address_2'}
                //,{text: '', value: 'reciver_address_3'}
                ,{text: 'ขอใบกำกับภาษี', value: 'is_taxinvoice'}
                ,{text: 'หมายเหตุ', value: 'note'}
            ]
            ,rows:[]
            ,export_header : [
                {text: 'OrderID', value:'order_id'}
                ,{text: 'LINE', value: 'line_name'}
                ,{text: 'สถานะ', value: 'status'}
                ,{text: 'ชื่อผู้สั่ง', value: 'order_name'}
                ,{text: 'ชื่อผู้รับของ', value: 'reciver_name'}
                ,{text: 'เบอร์ผู้รับของ', value: 'reciver_tel'}
                ,{text: 'ที่อยู่จัดส่งชุด', value: 'reciver_address_1'}
                ,{text: '', value: 'reciver_address_2'}
                ,{text: '', value: 'reciver_address_3'}
                ,{text: 'หมายเหตุ', value: 'note'}
                ,{text: 'สินค้าที่สั่ง', value: 'product_name'}
                ,{text: 'ตัวเลือกสินค้า', value: 'item_name'}
                ,{text: 'ราคาสินค้า', value: 'total_price'}
                ,{text: 'ค่าจัดส่ง', value: 'total_fee'}
                ,{text: 'รวมที่ต้องจ่าย', value: 'total_bill'}
                ,{text: 'วันที่สั่ง', value: 'order_date'}
                ,{text: 'ขอใบกำกับภาษี', value: 'is_taxinvoice'}
                ,{text: 'ชื่อผู้เสียภาษี', value: 'tax_name'}
                ,{text: 'เลขผู้เสียภาษี', value: 'tax_id'}
                ,{text: 'ที่อยู่ผู้เสียภาษี', value: 'tax_address_1'}
                ,{text: '', value: 'tax_address_2'}
                ,{text: '', value: 'tax_address_3'}
                ,{text: 'อีเมลรับใบกำกับภาษี', value: 'tax_email'}
            ]
        }
    },
    mounted : function () {
        var que = this.$store.commit('addLoading')
        this.permission = Staff.getPermission('SpecialMarket').then(permission=>{
            this.$store.commit('finishLoading',que)
            this.permission = permission
            if(this.permission.includes('VIEW_specialmarketorder')){
                this.reload()
            }
        })
    },
    methods : {
        csvExport() {
            var rearragedata = []
            this.rows.forEach(r=>{
                var value = []
                this.export_header.forEach(h=>{
                    var val = ""
                    h = h.value
                    val = r[h] != undefined ? r[h].toString() : ""
                    val = val.replace(',','|')
                    value.push(val)
                })
                rearragedata.push(value.join(','))
            })
            let csvContent = "data:text/csv;charset=utf-8," + "\ufeff";
            csvContent += [
                this.export_header.map(h=>h.text).join(","),
                ...rearragedata
            ].join("\n");
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "rapidtest_order.csv");
            link.click();
        },
        reload(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.specialmarket.get_orderlist
                ,{}
                ,{ headers: Staff.getTokenHeader()}
            ).then(response => {
                this.$store.commit('finishLoading',que)
                this.rows = response.data
                this.rows.forEach((r,i,arr)=>{
                    arr[i].is_taxinvoice = r.is_taxinvoice ? 'ขอใบกำกับภาษีด้วย' : 'ไม่'
                    var d = new Date(r.order_date)
                    d.setHours(d.getHours()+7)
                    arr[i].order_date = d.toISOString().substring(0,10) + ' ' + d.toISOString().substring(11,19);
                    arr[i]['total_bill'] = parseInt(r.total_price) + parseInt(r.total_fee)
                    arr[i]['total_price_text'] = r.total_price + ' บาท'
                    arr[i]['total_fee_text'] = r.total_fee + ' บาท'
                    arr[i]['total_bill_text'] = arr[i]['total_bill'] + ' บาท'
                    arr[i]['product_item_name'] = r.product_name + ' ' + r.item_name
                })
            })
        }
    }
}
</script>